import { render, staticRenderFns } from "./GiftDetail.vue?vue&type=template&id=7d051c76&scoped=true&"
import script from "./GiftDetail.vue?vue&type=script&lang=js&"
export * from "./GiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./GiftDetail.vue?vue&type=style&index=0&id=7d051c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d051c76",
  null
  
)

export default component.exports